export enum ProofKeyTab {
  payment = 'payment',
  vatTax = 'vatTax',
  incomeTax = 'incomeTax',
}
